import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { Modal, Button, Badge } from 'ant-design-vue'
Vue.use(Button)
Vue.use(Modal)
Vue.use(Badge)

// import axios from 'axios';
import VueAuthenticate from 'vue-authenticate'
import VueAxios from 'vue-axios'
import Server from './$server'
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import TimeAgo from 'javascript-time-ago';
// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en'

// custom functions
import store from "./store";
import API from "./Api";
import loader from "./loader";
import jquery from "jquery";
import substring from "./functions/substring";
import getDateYear from "./functions/getDateYear";
import validate from "./functions/validate";
import updateLocalData from "./functions/updateLocalData";
import urlify from "./functions/urlify";

window.eventBus = new Vue();

Vue.config.productionTip = false

var top = window.screen.height - 300;
    top = top > 0 ? top/5 : 0;

var left = window.screen.width - 400;
    left = left > 0 ? left/2 : 0;

Vue.use(VueAxios,Server);
Vue.use(Loading);

TimeAgo.addLocale(en);
// Create relative date/time formatter.
const timeAgo = new TimeAgo('en-US');


// prototypes
Vue.prototype.$api = API;
Vue.prototype.$loader = loader;
Vue.prototype.$Jquery = jquery;
Vue.prototype.$substring = substring;
Vue.prototype.$timeAgo = timeAgo;
Vue.prototype.$getDateYear = getDateYear;
Vue.prototype.$validate = validate;
Vue.prototype.$storeLocalData = updateLocalData;
Vue.prototype.$urlify = urlify;

new Vue({
  router,
  store,
  mounted() {
    window.eventBus.$on("logout", id => {
      if (id === true) {
        store.commit('logout');
        // store.commit('resetState');
        window.location="/";
      }
    });
  },
  render: h => h(App),
}).$mount('#app')
